import styled, { css } from "styled-components";
import sectionBgImage from "../../../assets/images/bg/h1_banner_bg.png";

const BannerV1Wrapper = styled.section`
  background: url(${sectionBgImage});
  min-height: 950px;
  width: 100%;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  padding-top: 192px;

  .hermes_v1_baner_right {
    margin-top: 66px;
    margin-left: auto;
    max-width: 500px;
    width: 100%;
    min-height: 550px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    h2 {
      font-family: "Bakbak One";
      font-style: normal;
      font-weight: 400;
      font-size: 60px;
      line-height: 80px;
      text-transform: uppercase;
      color: #ffffff;
      margin-bottom: 32px;
    }

    h3 {
      font-family: "Bakbak One";
      font-style: normal;
      font-weight: 400;
      font-size: 40px;
      line-height: 60px;
      text-transform: uppercase;
      color: #ffffff;
    }

    .banner_buttons {
      display: flex;
      column-gap: 30px;
      margin-top: 58px;
    }

    .coin-info {
      display: flex;
      flex-direction: column;
      margin-top: 37px;
      span {
        font-family: "Bakbak One";
        font-size: 18px;
        line-height: 36px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.8);

        & .highlighted {
          color: var(--primary-color);
        }
      }
    }
  }

  .hermes_v1_baner_left {
    max-width: 500px;
    width: 100%;
    margin-top: 66px;
    margin-left: auto;

    .hermes_v1_baner_left_img_sect {
      position: relative;
      width: 100%;
      height: 550px;
      display: flex;
      align-items: center;
      justify-content: center;

      .hermes_v1_baner_left_img {
        position: relative;
        border: 10px solid var(--primary-color);
        z-index: 1;
      }
    }
  }

  @media only screen and (max-width: 1199px) {
    .hermes_v1_baner_right {
      h2 {
        font-size: 50px;
        line-height: 65px;
      }

      h3 {
        font-size: 34px;
        line-height: 38px;
      }

      .baner_buttons {
        margin-top: 40px;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    padding-top: 50px;
    min-height: 800px;
    .hermes_v1_baner_right {
      margin-top: 0px;
      margin-left: auto;
      margin-right: auto;
      justify-content: flex-start;
      min-height: 450px;
    }

    .hermes_v1_baner_left {
      margin: 70px auto;
      max-width: 568px;
      width: 100%;
      min-height: 450px;

      .hermes_v1_baner_left_img {
        width: 90%;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .hermes_v1_baner_right {
      h2 {
        font-size: 40px;
        line-height: 50px;
        margin-bottom: 20px;
      }

      h3 {
        font-size: 28px;
        line-height: 38px;
      }

      .banner_buttons {
        margin-top: 25px;
      }
    }

    .hermes_v1_baner_left {
      margin-top: 100px;
      .hermes_v1_baner_left_img_sect {
        height: 450px;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .hermes_v1_baner_left {
      margin-bottom: 10px;
      margin-top: 50px;

      .hermes_v1_baner_left_img {
        width: 100%;
      }
    }

    .hermes_v1_baner_right {
      h2 {
        font-size: 37px;
      }

      h3 {
        font-size: 22px;
      }

      .coin-info {
        font-size: 14px;
        line-height: 29px;
      }

      .banner_buttons {
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: flex-start;
        column-gap: unset;

        .hermes-btn {
          width: 180px;
        }
      }
    }
  }

  @media (max-width: 375px) {
    .hermes_v1_baner_right {
      h2 {
        font-size: 35px;
      }
      h3 {
        font-size: 22px;
      }
    }
  }

  @media (max-width: 360px) {
    .hermes_v1_baner_right {
      .coin-info {
        font-size: 13px;
      }
    }
  }
`;

const BannerContent = styled.div`
  ${({ variant }) =>
    variant === "homev1" &&
    css`
      position: relative;
      border: 10px solid var(--primary-color);
      z-index: 1;
    `}
  ${({ variant }) =>
    variant === "homev2" &&
    css`
      position: relative;
      border: 10px solid var(--primary-color);
      z-index: 1;
    `}
  ${({ variant }) =>
    variant === "homev3" &&
    css`
      position: relative;
      border: 10px solid var(--primary-color);
      z-index: 1;
    `}
`;

export { BannerV1Wrapper, BannerContent };
